<template>
  <div>
    <!-- TODO: refactor markup Header Component-->
    <b-navbar  type="light" fixed="top" toggleable="lg" class="navbar-default py-0">
      <b-container>
        <b-navbar-brand href="#">
          <img src="@/assets/images/logos/logo.svg" alt="logo"/>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <mainMenu></mainMenu>
          <b-navbar-nav class="ml-auto my-2 my-sm-0">
            <userDataMenu/>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

  </div>
</template>

<script>
import mainMenu from './main_menu'
import userDataMenu from './user_data_menu'

export default {
  name: 'privateHeader',
  components: { mainMenu, userDataMenu }
}
</script>
